// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__tEljS","insightsList":"newBusinessInsightsMenu_insightsList__GJKV_","active":"newBusinessInsightsMenu_active__1dK3i"};